// extracted by mini-css-extract-plugin
export default {"watchNumber":"Watch_watchNumber__k74Zh","watchDivision":"Watch_watchDivision__I7q45"};